import script from "./BreadcrumbsBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./BreadcrumbsBlock.vue?vue&type=script&setup=true&lang=ts"

import "./BreadcrumbsBlock.vue?vue&type=style&index=0&id=2f43fcc4&lang=scss"

const __exports__ = script;

export default __exports__